import {useEffect, useId} from 'react';
import {ErrorNotice, Loading} from './components';
import type {HermesState} from './lib/types';
import type {hermesActions} from './lib/store';
import {DiscordLogo} from './auth';

export function DiscordSettings({state, actions}: {state: HermesState; actions: typeof hermesActions}) {
  const titleId = useId(), accountId = state.session.data?.accountId;
  const status = state.discord.data;
  const configured = state.config.status === 'ready' && state.config.data?.discordConfigured === true;
  useEffect(() => {
    if (!accountId) return;
    const read = () => {if (document.visibilityState === 'visible') void actions.refreshDiscord().catch(() => undefined);};
    read(); document.addEventListener('visibilitychange', read);
    return () => document.removeEventListener('visibilitychange', read);
  }, [accountId, actions]);
  return <section className="settings-section" aria-labelledby={titleId}>
    <div className="settings-description"><h2 id={titleId}>Discord</h2>
      <p>Use your Discord account to sign in to Eightbots.</p>
      {status?.signInLinked && <p>Sign-in is linked to {status.username}.</p>}
      {state.config.status === 'ready' && !configured && <p>Discord sign-in is not configured.</p>}
    </div>
    <div><ErrorNotice error={state.discord.error}/><Loading active={state.discord.status === 'loading'}/>
      {status && !status.signInLinked && <button type="button" className="button discord-link-button" disabled={!configured || state.operation.label !== null}
        onClick={() => void actions.linkDiscordSignIn().catch(() => undefined)}><DiscordLogo/>Enable Discord sign-in</button>}
    </div>
  </section>;
}
